<template>
  <FilterMultiChip
    is-text
    :label-mode="labelMode"
    icon="vote"
    :label="$t('search-filters.vote-request')"
    :items="items"
    :value="value || []"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FilterMultiChip from '@/components/filters/FilterMultiChip';
import { LABEL_MODE } from '@/components/filters/label-mode';

// Sentinel id used by the backend for "no vote requested".
const NONE_VOTE_ID = '00000000-0000-0000-0000-000000000000';
const PENDING_VOTE_ID = 'pending';

/**
 * Vote-request dimension chip. Presentational: `:value` (array of voter ids) + `:users` (the
 * roster the page owns) in, `change` out. Prepends "none" and "pending" options.
 */
export default {
  name: 'VoteChip',
  components: { FilterMultiChip },
  props: {
    value: { type: Array, default: () => [] },
    users: { type: Array, default: () => [] },
  },
  computed: {
    labelMode: () => LABEL_MODE.COLLAPSE,
    items() {
      const none = { value: NONE_VOTE_ID, text: this.$t('go-nogo.none') };
      const pending = { value: PENDING_VOTE_ID, text: this.$t('go-nogo.pending') };
      const userItems = (this.users || [])
        .map((user) => ({ value: user.id, text: user.fullName }))
        .sort((a, b) => (a.text || '').localeCompare(b.text || ''));
      return [none, pending, ...userItems];
    },
  },
};
</script>
